<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c8/kmdiet_01.png" />
        <img class="imgs" src="../../../assets/c8/kmdiet_02.png" />
        <img class="imgs" src="../../../assets/c8/kmdiet_03.png" />
        <img class="imgs" src="../../../assets/c8/kmdiet_04.png" />
        <img class="imgs pb_5" src="../../../assets/c8/kmdiet_05.png" />
        <img class="imgs c8_ibtn_cta"  @click="goLink" src="../../../assets/c8/btn_floot_cta_m.png" />
        <!-- <img class="imgs" src="../../../assets/c8/kmdiet_08.png" /> -->
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'kmdiet',
    methods: {
        goLink: function()
        {
            window.open('http://bit.ly/3Xq9OFI', '_blank');
        },
        gokakao: function(eventname)
        {
            this.conversionApi(eventname);
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 96598},

                // To Do 1. 현재 유저의 이메일 주소(공백 제거 및 소문자로 변환 후) 전달. 유저의 이메일을 알수 없는 상황이면 빈 문자열로 전달
                { event: "setEmail", email: "##User Email##" },

                // To Do 2. 현재 유저의 저장된 배송지 우편번호. 유저의 배송지 우편번호를 알수 없는 상황이면 빈 문자열로 전달
                { event: "setZipcode", zipcode: "##Zip Code##" },

                { event: "setSiteType", type: deviceType},

                // To Do 3. 확인 또는 주문 번호를 전달
                // Tip 1. 다른 종류의 전환일 경우 상품 ID에 다른 값으로 전달하여 나중에 리포트를 통해 확인 가능
                { event: "trackTransaction", id: Math.floor(Math.random()*99999999999), item: [
                    {id: "1", price: 1, quantity: 1 }
                ]}
            );

             window.open('https://plus.kakao.com/talk/bot/@솔닥/솔닥%20원격진료%20시작하기', '_blank');
        },
        conversionApi: function(eventname)
        {
            const time = Date.now();
            let stime = time.toString().slice(0, 10);
            const data = {
                data: 
                [
                    {
                        event_name: eventname,
                        // text_event_code: "TEST43477",
                        event_time: Number(stime),
                        action_source: "email",
                        user_data: {
                            em: [
                                "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068"
                            ],
                            ph: [
                                null
                            ]
                        },
                        custom_data: {
                            "currency": "USD",
                            "value": "142.52"
                        }
                    }
                ]
            }
            return axios({
                method: 'post',
                url: 'https://graph.facebook.com/v15.0/580521327268842/events?access_token=EAAHIPxRrOeYBAHfdaUR70ZAZA8EamzQKUvK8aqMnrYkvKZALvCbi7C7Etg0n16uhtxUxRZCxAeZCaiWaUTM7yJs4wbkfZC3omvYc14FoImXXN1ciRHtBv2tZB3fCzeRb9ppQR9oP2aGJwqJVNR0btsZCOrhrj9s7KiGv3mnCPPNiOau6kUUG95nchnH5mSdOyBkZD.',
                data: data
            })
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
    }
    .imgs  {
        width: 100%;
    }
    .pb_5{
        padding-bottom: 20px;
    }
    .c8_ibtn_cta{
        position: fixed;
        bottom: 10px;
        width: auto;
        max-width: 100%;
        z-index: 10;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_view/contents/c8.vue